<template>
  <component
    v-if="headerVisible"
    :title="title"
    :holder="holder"
    :routeNameProps="routeNameProps"
    :topBarBgcolor="topBarBgcolor"
    :topBarColor="topBarColor"
    :topBarBgImage="topBarBgImage"
    :appbarStyle="appbarStyle"
    :appbarClass="appbarClass"
    :is="
      _config.app_config.configValue.template && _config.app_config.configValue.template.header
        ? _config.app_config.configValue.template.header
        : 'default1'
    "
  >
    <slot slot="left" name="left"></slot>
    <slot></slot>
    <slot slot="right" name="right"></slot>
  </component>
</template>

<script>
import appConfigMixins from '@c/mixins/appConfig.mixins'
export default {
  mixins: [appConfigMixins],
  props: {
    title: {
      type: [String],
      default: ''
    },
    holder: {
      type: [Boolean],
      default: true
    },
    topBarBgcolor: {
      type: String,
      default: ''
    },
    topBarColor: {
      type: String,
      default: ''
    },
    topBarBgImage: {
      type: String,
      default: ''
    },
    appbarClass: {
      default: ''
    },
    appbarStyle: {
      default: ''
    },
    routeNameProps: {
      type: String,
      default: ''
    }
  },
  components: {
    default1: () => import('@t/Appbar/default1'),
    Venice01: () => import('@t/Appbar/Venice01'),
    forum3: () => import('@t/Appbar/forum3'),
    newyaboLottery: () => import('@t/Appbar/newyaboLottery'),
    nox: () => import('@t/Appbar/nox'),
    VeniceDark: () => import('@t/Appbar/default1')
  },
  mounted() {},
  computed: {
    headerVisible() {
      return this.$store.state.app.headerVisible
    }
  }
}
</script>
